import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  Card,
  CardContent,
  Grid,
  // TextField,
  FormControl,
  InputLabel,
  Select,
  // MenuItem,
  Button,
  MenuItem,
  OutlinedInput,
  // Divider,
  // Typography,
  // CircularProgress,
} from '@material-ui/core'
// import Autocomplete from '@material-ui/lab/Autocomplete'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as yup from 'yup'
import {
  //  useNavigate,
  useParams,
} from 'react-router-dom'
// import { debounce } from 'lodash'
import {
  getAllAgeCategories,
  // selectorAgeCategories
} from 'src/app/slices/notificationSlice'
// import { selectorEventStages } from 'src/app/slices/eventSlice'
import { addEventStage, getEvents, selectorEvents } from 'src/app/slices/eventSlice'
import {
  // createGroup,
  // getGroupMembers, addMembers, deleteMembers,
  getGroups,
  // getGroup,
} from '../../app/slices/refereeGroupsSlice'
import { getUsers } from '../../app/slices/usersSlice'
import { CssTextField, StyledMenuItem } from '../../utils/CustomInputs'
// import muiDefaultOptions from '../../constants/muiTableOptions'

const useStyle = makeStyles(() => ({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: '#f9b233',
    },
    '& .MuiOutlinedInput-input:focus': {
      outline: 'red',
    },
    '& .MuiMenuItem-root': {
      '&:hover': {
        backgroundColor: '#f9b233',
      },
    },
    '.MuiMenuItem-root': {
      backgroundColor: '#f9b233',
    },
  },
  inputs: {
    width: '100%',
  },
}))

const ORDERS = [
  { title: 'مرحله اول', value: 1 },
  { title: 'مرحله دوم', value: 2 },
]

const validationSchema = yup.object({
  title: yup
    .string('لطفا نام گروه را وارد کنید')
    .required('نام گروه الزامی است.'),
  eventId: yup
    .string('')
    .required('انتخاب نقش الزامی است'),
})

const GroupForm = () => {
  const classes = useStyle()
  // const navigate = useNavigate()
  const dispatch = useDispatch()

  // const { groupId, groupName, ageId } = useParams()
  const { groupId } = useParams()
  // const ages = useSelector(selectorAgeCategories)
  const events = useSelector(selectorEvents)
  const groups = useSelector((state) => state.refereeGroups.list)
  const loggedInUser = useSelector((state) => state.user)
  const groupReferees = useSelector((state) => state.refereeGroups.refereeGroup)
  const roles = useSelector((state) => {
    if (loggedInUser.role.roleId === 5) {
      return state.common.roles.filter((role) => role.roleId === 6)
    } if (loggedInUser.role.roleId === 3) {
      return state.common.roles.filter(
        (role) => (
          role.roleId !== 2 && role.roleId !== 1 && role.roleId !== 8 && role.roleId !== 3
        ),
      )
    } if (loggedInUser.role.roleId === 2) {
      return state.common.roles.filter((role) => role.roleId !== 1)
    }
    return []
  })

  const [refereeGroups, setRefereeGroups] = useState([])

  useEffect(() => {
    dispatch(getEvents())
  }, [])

  // useEffect(() => {
  //   dispatch(getGroup(+refereeGroups))
  // }, [refereeGroups])

  useEffect(() => {
    dispatch(getUsers({
      roleIds: roles.map((role) => role.roleId),
      after: 0,
      first: 1000,
      full: true,
    }))
    dispatch(getGroups({ type: 2 }))
    dispatch(getAllAgeCategories())
  }, [])

  // const group = groups?.find((g) => +g?.id === +groupId)
  // const ageCategory = ages?.find((age) => +age?.ageCategoryId
  //  === +group?.ageCategory?.ageCategoryId)

  const formik = useFormik({
    initialValues: {
      title: '',
      eventId: '',
      order: '',
      efereeGroups: refereeGroups,
      // refereeGroups: '',
    },
    validationSchema,
    onSubmit: (values) => {
      const data = {
        Title: values?.title || null,
        EventId: values.eventId || null,
        Order: values.order || null,
        RefereeGroups: refereeGroups?.map((item) => {
          return { id: item }
        }) || '',
      }

      console.log(data, 'dchnfgyjytjkuy')
      dispatch(addEventStage(data))
      // if (groupId) return
      // dispatch(createGroup({
      //   Title: values?.title || null,
      //   EventId: values.eventId || null,
      //   Order: values.order || null,
      //   RefereeGroups: values.refereeGroups || null,
      // }, (data) => {
      //   // navigate(`../edit/${data}/${values.age}/${values.name}`)
      //   navigate(`../edit/${data}`)
      // }))
    },
  })

  console.log(groupReferees, 'groupReferees')

  // const names = [
  //   'Oliver Hansen',
  //   'Van Henry',
  //   'April Tucker',
  //   'Ralph Hubbard',
  //   'Omar Alexander',
  //   'Carlos Abbott',
  //   'Miriam Wagner',
  //   'Bradley Wilkerson',
  //   'Virginia Andrews',
  //   'Kelly Snyder',
  // ]

  // const [personName, setPersonName] = React.useState([])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    // setPersonName(
    //   // On autofill we get a stringified value.
    //   typeof value === 'string' ? value.split(',') : value,
    // )
    // const refereeArr = [...personName]
    // const data = {
    //   id: value?.toString(),
    // }
    // refereeArr.push(data)
    // console.log(refereeArr, 'personNamezdvsvg')

    setRefereeGroups(value)
  }

  const changing = refereeGroups?.map((item) => {
    return { id: item }
  })
  console.log(refereeGroups, 'personNamezdvsvg')
  console.log(changing, 'personNamezdvsvg')

  return (
    <Card className={classes.root}>
      <CardContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2}>

            <Grid item xs={12} sm={6}>
              <CssTextField
                fullWidth
                variant="outlined"
                // disabled={!!groupId}
                id="title"
                name="title"
                label="عنوان مرحله"
                value={formik.values.title}
                onChange={formik.handleChange}
                // error={formik.touched.name && Boolean(formik.errors.name)}
                // helperText={formik.touched.name && formik.errors.name}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel id="eventId">رویدادها</InputLabel>
                <Select
                  labelId="eventId"
                  id="eventId"
                  name="eventId"
                  // disabled={ageCategory?.name}
                  value={formik.values.eventId}
                  onChange={formik.handleChange}
                  label="رویدادها"
                >
                  {events?.length && events?.map((e) => (
                    <StyledMenuItem key={e} value={e?.id}>
                      {e?.title}
                    </StyledMenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel id="order">مرحله</InputLabel>
                <Select
                  labelId="order"
                  id="order"
                  name="order"
                  fullWidth
                  // disabled={ageCategory?.name}
                  value={formik.values.order}
                  onChange={formik.handleChange}
                  label="گروه"
                >
                  {ORDERS?.map((g) => (
                    <StyledMenuItem key={g?.value} value={g?.value}>
                      {g?.title}
                    </StyledMenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel id="demo-multiple-name-label">گروه</InputLabel>
                <Select
                  labelId="refereeGroups"
                  id="refereeGroups"
                  name="refereeGroups"
                  multiple
                  value={refereeGroups}
                  onChange={handleChange}
                  input={<OutlinedInput label="Name" />}
                  // MenuProps={MenuProps}
                >
                  {groups?.map((g) => (
                    <MenuItem
                      key={g?.id}
                      value={g?.id}
                      // style={getStyles(name, personName, theme)}
                    >
                      {g?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/*
            <Grid item xs={12} sm={6}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel id="refereeGroups">گروه</InputLabel>
                <Select
                  labelId="refereeGroups"
                  id="refereeGroups"
                  name="refereeGroups"
                  // disabled={ageCategory?.name}
                  // value={formik.values.refereeGroups}
                  // onChange={formik.handleChange}
                  value={refereeGroups}
                  onChange={(e) => setRefereeGroups(e?.target?.value)}
                  label="گروه"
                >
                  {groups?.length && groups?.map((g) => (
                    <StyledMenuItem key={g?.id} value={g?.id}>
                      {g?.name}
                    </StyledMenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid> */}

            {/* <Grid item xs={12} sm={6}>
              <Autocomplete
                multiple
                id="tags-outlined"
                options={groupReferees}
                getOptionLabel={(option) => option?.userName}
                // defaultValue={[groupReferees?.[13]]}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="داورها"
                    // placeholder="داورها"
                    variant="outlined"
                  />
                )}
              />
            </Grid> */}

            <Grid
              item
              xs={12}
              style={{
                display: groupId ? 'none' : '',
              }}
            >
              <Button color="primary" variant="contained" fullWidth type="submit">
                ذخیره
              </Button>
            </Grid>
            {/* {groupId ? <Grid item xs={12}><GroupMembers groupId={groupId} /></Grid> : null} */}
          </Grid>
        </form>

      </CardContent>
    </Card>
  )
}

export default GroupForm
